<template lang="html">
    <entity-page id="page__extrasize" v-bind:loading="progress">
      	<template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded @click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded @click="save"></z-icon-button>
        </template>
		<div class="row">
			<z-select
				label="Тип расчёта" v-model="extrasize.type" :required="true" name="type" id="type" class="col-6"
				v-validate="'required'" v-bind:data-vv-as="' '" data-vv-name="type" v-bind:error="errors.first('type')"
			>
				<option default v-bind:value="null"> Выбрать... </option>
				<option value="weight"> По весу </option>
				<option value="volume"> По объёму </option>
				<option value="dimensions"> По габариту </option>
				<option value="dimensionssum"> По сумме габаритов </option>
			</z-select>

			<z-select
				label="Тип наценки" v-model="extrasize.markup_type" :required="true" name="markup_type" id="markup_type" class="col-6"
				v-validate="'required'" v-bind:data-vv-as="' '" data-vv-name="markup_type" v-bind:error="errors.first('markup_type')"
			>
				<option default v-bind:value="null"> Выбрать... </option>
				<option v-bind:value="1"> Числовая </option>
				<option v-bind:value="2"> Процентная </option>
			</z-select>

			<z-input
				v-model="extrasize.min" name="min" id="min"
				v-bind:label="('Минимум ' + sizeUnits)" class="col-6"
				v-validate="{'required': true, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}" 
				v-bind:required="true" v-bind:error="errors.first('min')" type="number" v-bind:data-vv-as="' '" data-vv-name="min"
			></z-input>

			<z-input
				v-model="extrasize.max" name="max" id="max"
				v-bind:label="('Максимум ' + sizeUnits)" class="col-6"
				v-validate="{'required': true, min_value: 0.001, max_value: 9999999999, decimal: [3, '.']}" 
				v-bind:required="true" v-bind:error="errors.first('max')" type="number" v-bind:data-vv-as="' '" data-vv-name="max"
			></z-input>

			<z-input
				v-model="extrasize.markup_value" label="Величина наценки" name="markup_value" id="markup_value"
				v-validate="{'required': true, min_value: 0.01, max_value: 9999999999, decimal: [2, '.']}"  class="col-6"
				v-bind:required="true" v-bind:error="errors.first('markup_value')" type="number" v-bind:data-vv-as="' '" data-vv-name="markup_value"
			></z-input>
		</div>
	</entity-page>
</template>
<script>
  import ZInput from '@/components/ZInput';
  import ZSelect from '@/components/ZSelect';
  import ZIconButton from '@/components/ZIconButton';
  import EntityPage  from '@/components/EntityPage.vue';
  export default {
    components: { ZInput, ZSelect, EntityPage, ZIconButton },
    data() {
      return {
        title: 'Негабарит',
        extrasize: {},
        extrasizeDefault: {
          id: null,
          type: 'weight',
          markup_type: 1,
          markup_value: 0,
          min: 1,
          max: 2
        },
      }
    },
    computed: {
		/**
		 * Список цен
		 */
		extrasizes() {
			return this.$store.state.cost.extrasizes;
		},
		/**
		 * Определение единиц измерения
		 */
		sizeUnits() {
			let result = 'кг';
			switch (this.extrasize.type) {
				case 'weight': result = 'кг'; break;
				case 'volume': result = 'м<sup>3</sup>'; break;
				case 'dimensions':    result = 'м'; break;
				case 'dimensionssum': result = 'м'; break;
				default:  result = 'кг';
			}
			return result;
		},
		/**
		 * Флаг загрузки текущего компонента
		 */
		progress() {
			return this.progressObj['load-extrasize-card'];
		},
		/**
		 * Объект с флагами загрузки
		 */
		progressObj() {
			return this.$store.state.progressObj;
		},
    },
    created() {
		this.init();
    },
    methods: {
		/**
		 * Инициализация компонента
		 */
		init() {
			this.$store.commit('setTitle', this.title);
			this.$store.commit('openRightPanel');
			this.extrasize = Object.assign({}, this.extrasizeDefault);
			this.getExtrasize();
		},
		/**
		 * Получение цены
		 */
		getExtrasize() {
			if (!this.$route.params.setting_id || this.$route.params.setting_id == 'new') return;
			this.$store.commit('showProgressBar', 'load-extrasize-card');
			return this.$store.dispatch('cost/getExtrasize', {id: this.$route.params.setting_id}).then((r) => {
				if (!r) return;
				this.extrasize = Object.assign({}, r);
				return this.extrasize
			}).finally(() => this.$store.commit('hideProgressBar', 'load-extrasize-card'));
		},
		/**
		 * Сохранение
		 */
		save() {
			this.$validator.validateAll().then((valid) => {
				if (!valid) return;
				if (!this.extrasize.id || this.extrasize.id == 'new') this.postExtrasize();
				else this.putExtrasize();
			});
		},
		/**
		 * Добавление цены
		 */
		postExtrasize() {
			this.$store.commit('showProgressBar', 'load-extrasize-card');
			this.$store.dispatch('cost/postExtrasize', this.extrasize).then(r => {
				if (!r) return;
				this.$root.$emit('reload-table', 'freightextrasize');
				this.$router.replace({name: 'Extrasize', params: {setting_id: r.id}});
			}).finally(() => this.$store.commit('hideProgressBar', 'load-extrasize-card'));
		},
		/**
		 * Изменение цены 
		 */
		putExtrasize() {
			this.$store.commit('showProgressBar', 'load-extrasize-card');
			this.$store.dispatch('cost/putExtrasize', this.extrasize).then(r => {
				if (!r) return;
				this.init();
				this.$root.$emit('reload-table', 'freightextrasize');
			}).finally(() => this.$store.commit('hideProgressBar', 'load-extrasize-card'));
		},
		/**
		 * Возвращает пользователя на предыдущую страницу
		 * Обрабочик события click, на кнопке "Закрыть"
		 */
		back() {
			this.$router.push({name: 'Extrasizes', query: this.$route.query});
		}
    },
	watch: {
		'$route.params.setting_id'() {
			this.init();
		},
    },
  }
</script>



// WEBPACK FOOTER //
// FreightExtrasize.vue?61c81e84